import React, { useState } from "react";
import { Form, Input, Button, notification } from "antd";
import { Auth } from "../services/authService"; // Ajusta la ruta según tu estructura
import LogoImg from "../assets/Logo2.jpg";
import Modal from "../components/Modal";
import { COLORS } from "../config/theme";
import {
  USER,
  USERID,
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USERNAME,
} from "../config/constants";
import "./Login.css";
import { STRINGS } from "../dictionaries/ESP.dictionary";
import { useAuth } from "../hooks";
import { useNavigate } from "react-router-dom";
import { fontSize } from "@mui/system";

const Login = () => {
  const authController = new Auth();

  const [inputs, setInputs] = useState({
    userName: "",
    password: "",
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isVisibleModalPassword, setIsVisibleModalPassword] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const changeForm = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    });
  };

  const gotoRecuperarPassword = () => {
    navigate("/recuperarPassword");
  };

  const handleLogin = async (event) => {
    setLoading(true);
    try {
      const response = await authController.login(
        inputs.userName,
        inputs.password
      );

      if (response.data.access) {
        localStorage.setItem(ACCESS_TOKEN, response.data.access);
        localStorage.setItem(REFRESH_TOKEN, response.data.refresh);
        localStorage.setItem(USER, JSON.stringify(response.data.user));
        localStorage.setItem(USERID, JSON.stringify(response.data.user.id_usuario));
        localStorage.setItem(USERNAME, response.data.user.nombre);
      }
      if (response.data.access) {
        login(response.data.access, response.data.user.nombre);
      }
    } catch (error) {
      console.log("ERROR:", error);
      notification["error"]({
        message: error?.response?.data?.message || "No se pudo autenticar el usuario",
      });
    } finally {
      setLoading(false);
    }
  };

  const goToRegistracion = () => {
    navigate("/registracion");
  };

  return (
    <div className="sign-in-Page">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="loginForm"
          style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
            }}
            className="containerLogo"
          >
            <a href="https://moron.gob.ar">
              <img src={LogoImg} alt="Logo Trimealo" className="centeredLogo" />
            </a>
          </div>
          <h4>{STRINGS.TITLE_PLATFORM}</h4>
          <Form className="containerControls" onFinish={handleLogin}>
            <div style={{ paddingBottom: "3vh", width: "100%" }}>
              <label className="loginInputLabel">{STRINGS.USERNAME}</label>
              <Input
                name="userName"
                placeholder="Ingrese su usuario"
                className="login-form__input"
                onChange={changeForm}
              />
            </div>
            <label className="loginInputLabel">{STRINGS.PASSWORD}</label>
            <Input.Password
              name="password"
              placeholder="Ingrese su contraseña"
              className="login-form__input"
              onChange={changeForm}
              visibilityToggle={{
                visible: passwordVisible,
                onVisibleChange: setPasswordVisible,
              }}
            />
            <div className="containerLoginButton" style={{ paddingTop: "1rem" }}>
              <Button
                className="login-form__button"
                loading={loading}
                htmlType="submit"
              >
                {STRINGS.ENTER}
              </Button>
            </div>
            <div className="containerButtons">
              <div
                style={{
                  paddingTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={gotoRecuperarPassword}
              >
                <span className="buttonRecuperarContraseña">
                  {STRINGS.PASSWORD_RECOVERY}
                </span>
              </div>
              <div
                style={{
                  paddingTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={goToRegistracion}
              >
                <span className="buttonRecuperarContraseña">
                  {STRINGS.REGISTER}
                </span>
              </div>
            </div>
            <div className="containerButtons">
              <div
                style={{
                  paddingTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <span className="buttonRecuperarContraseña">
                  <a style={{color:"rgba(255, 255, 255, 0.8)", fontSize:"1.1rem"}} href="https://gestion-digital-s-site.thinkific.com/courses/ai-placeholder">Instructivo de Uso de Plataforma</a>
                </span>
              </div>
            </div>            
          </Form>
        </div>
        <Modal
          title={modalTitle}
          open={isVisibleModalPassword}
          setIsVisible={setIsVisibleModalPassword}
        >
          {modalContent}
        </Modal>
      </div>
    </div>
  );
};

export default Login;
